import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zTariffSchemaDom, zTariffSchemaCreateDom, } from "@/types/tariff/tariff.domain";
import { zTariffSchemaDto, zTariffSchemaCreateDto, } from "@/types/tariff/tariff.dto";
export const TariffMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zTariffSchemaDom.parse(dto),
    domainToDto: (domain) => zTariffSchemaDto.parse(domain),
    dtoToCreateDto: (domain) => zTariffSchemaCreateDto.parse(domain),
    dtoToCreateDom: (dto) => zTariffSchemaCreateDom.parse(dto),
});
